import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import RoutePointComponent from '../components/route-point.component';
import { routePoints } from '../../../../../redux/route-management/route-points/action';
import { selectRoutesListItems } from '../../../../../redux/route-management/routes/selector';
import { selectAgentsListItems } from '../../../../../redux/agents/selector';
import { selectRoutePointsQueryItems } from '../../../../../redux/route-management/route-points/selector';
import { routes } from '../../../../../redux/route-management/routes/action';
import { agents } from '../../../../../redux/agents/action';


const ManagementRoutePoint = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const routeLists = useSelector(selectRoutesListItems)
    const agentLists = useSelector(selectAgentsListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const routePointsQuery = useSelector(selectRoutePointsQueryItems)
    const [
        selectedRoutePoints,
        setSelectedRoutePoints
    ] = useState<any>([])


    const fetchRoutePointsQueryById = () => {
        dispatch(routePoints.query({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/route-points/query`, entity: 'routePoints', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedRoutePoints({ ...selectedRoutePoints, [field]: event })
    }



    useEffect(
        () => {
            dispatch(routes.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/routes/list`, entity: 'routes', jsonData: {}

            }))
                .then(() => {
                    dispatch(agents.list({
                        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`, entity: 'agents', jsonData: {}
                    }));
                }).then(() => {
                    if (parmas?.id > 0) {
                        fetchRoutePointsQueryById()
                        setIsLoading(false)
                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedRoutePoints(routePointsQuery?.result?.items)

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        if (parmas?.id > 0) {
            await dispatch(routePoints.resetAction({ actionType: 'update' }))
            await dispatch(routePoints.update({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/route-points`, entity: 'routePoints', jsonData: {

                    Records: [
                        selectedRoutePoints

                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(routePoints.resetAction({ actionType: 'create' }))
            await dispatch(routePoints.create({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/route-points`, entity: 'routePoints', jsonData: {

                    Records: [
                        selectedRoutePoints
                    ]

                }
            })).then(() => {
                back()
            })
        }

    }

    const back = () => {
        navigate('/management/route-management/route-points')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :


                <RoutePointComponent
                    routes={routeLists?.result?.items}
                    transportAgents={agentLists?.result?.items}
                    selectedRoutePoints={selectedRoutePoints}
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                />
            }

        </>
    )

}

export default ManagementRoutePoint;